import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { EuroIcon } from 'lucide-react';

const RevenueDisplay = ({ monthlyStats }) => {
  return (
    <div className="mt-6">
      <h3 className="text-xl font-semibold mb-2 flex items-center text-gray-900 dark:text-white">
        <EuroIcon className="mr-2 text-gray-700 dark:text-gray-300" size={20} />
        Revenus mensuels
      </h3>
      <div className="bg-white dark:bg-gray-700 p-4 rounded-lg shadow">
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={monthlyStats}>
            <CartesianGrid strokeDasharray="3 3" stroke="#9CA3AF" />
            <XAxis dataKey="name" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--tooltip-bg, #fff)',
                border: '1px solid #e5e7eb',
                borderRadius: '0.5rem'
              }}
            />
            <Legend />
            <Bar dataKey="amount" fill="#22C55E" name="Revenus (€)" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 text-right">
        <p className="text-lg font-semibold text-gray-900 dark:text-white">
          Total des revenus : {monthlyStats.reduce((sum, month) => sum + month.amount, 0).toFixed(2)}€
        </p>
      </div>
    </div>
  );
};

export default RevenueDisplay;